module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Catherine Tinley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Catherine Tinley is a multi award-winning writer of witty, heartwarming Regency Romance. Her first novel, "), _c('I', [_vm._v("Waltzing with the Earl")]), _vm._v(", won the Rita(R) Award for Best Historical Romance 2018, and she has since won the 2021 RoNA award, the 2021 HOLT medallion, and the 2022 RoNA award for Best Historical Romance. She lives in Ireland with her family and can be reached at www.CatherineTinley.com and on social media at https://linktr.ee/CTinley ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IX3rHl/tc-custom/9781488063770.jpg?1741150545132",
      "alt": "This image is the cover for the book Rags-to-Riches Wife"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rags-to-Riches Wife\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Marrying for inheritance… or love?  Lady’s maid Jane Bailey’s life is turned upside down by the arrival of wealthy gentleman Robert Kendal. Traveling together to claim her long-lost aristocratic grandfather’s inheritance, they succumb to a mutual attraction. Yet Jane knows a maid should not hope to love a gentleman, even if she’s suddenly wearing silk dresses and dining with the family. The will shockingly decrees Robert and Jane must marry, but will it ever be for more than convenience?  From Harlequin Historical: Your romantic escape to the past.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0